import React, { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { userAtom } from '../atom'; // Import the user atom
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

export const UserProvider = ({ children }) => {
  const setUser = useSetAtom(userAtom);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (authUser) => {
      if (authUser) {
        if (!authUser.emailVerified){
          return
        }
        // Fetch additional user data from Firestore
        const docRef = doc(db, "users", authUser.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          authUser["data"] = data; // Append additional data to the authUser object
        }

        setUser(authUser); // Set the user atom with the updated user object
        console.log(authUser);
      } else {
        setUser(null); // Set the user atom to null if no user is authenticated
      }
    });

    return () => unsubscribe(); // Cleanup subscription on unmount
  }, [setUser]);

  return <>{children}</>; // Just return children, no context provider needed
};

export default UserProvider;
